import { render } from "./v-report-salary.vue?vue&type=template&id=bc2799a4"
import script from "./v-report-salary.vue?vue&type=script&lang=js"
export * from "./v-report-salary.vue?vue&type=script&lang=js"

import exportComponent from "/builds/simplecrm/simplecrmfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__